<template>
  <div>
    <draggable
      class="inner"
      :list="orderedItems"
      group="order"
      @start="startDrag()"
      @end="endDrag()"
      :ref="name"
      :id="name"
      v-if="items"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="item"
        :data-id="item.id"
      >
        <p v-text="item.title" :key="`display-${index}`"></p>
        <v-icon @click="remove(index)" class="black--text"
          >mdi-close-circle</v-icon
        >
      </div>
    </draggable>

    <v-select
      label="Select an item"
      :items="orderedRefs"
      @change="change($event)"
      item-text="title"
      item-value="id"
    />
    <div class="overlay">
      <v-btn @click="add" :diabled="!selectedId">Add item</v-btn>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");
import { VTextField, VSelect } from "vuetify/lib";
import draggable from "vuedraggable";
import lodash from "lodash";
export default {
  name: "OrderedItems",
  data() {
    return {
      items: this.value,
      refs: null,
      fields: [],
      item: {},
      selectedId: null,
    };
  },
  props: {
    value: Array,
    name: String,
    collection: String,
  },
  components: {
    draggable,
  },
  computed: {
    orderedRefs() {
      return this.refs ? lodash.orderBy(this.refs, "title", "asc") : [];
    },
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      if (this.selectedId) {
        let selected = this.refs.find((x) => x.id == this.selectedId);
        let item = {
          index: this.items.length,
          title: this.populateField(selected.title),
          description: this.populateField(selected.description),
          slug: this.populateField(selected.slug),
          src: this.populateField(selected.src),
          id: this.selectedId,
        };
        this.items.push(item);
        this.selectedId = null;
      }
    },
    change(ev) {
      // this.item[ev.model] = val
      this.selectedId = ev;
    },
    remove(index) {
      this.items.splice(index, 1);
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        console.log(item);
        let indexOfItem = this.items.indexOf(item);
        item.index = count;
        vm.$set(vm.items, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
    createFields() {
      console.log("create fields");
      this.fields = [
        { component: VTextField, model: "title", label: "Title" },
        {
          component: VSelect,
          model: "benchmark",
          label: "Bencmark",
          items: this.refs,
        },
      ];
    },
    getRefs() {
      fb[this.collection]
        .get()
        .then((docs) => {
          let refs = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            refs.push(doc);
          });
          this.refs = refs;
          this.createFields();
        })
        .catch(() => {});
    },
    populateField(field) {
      return field ? field : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid white;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  background: white;
  margin-bottom: 3px;
  border-radius: 2px;
  p {
    margin: 0;
    padding: 0;
    color: black;
  }
}
</style>
